//List of Domains that should not be previewed in the content preview

export const CONTENT_PREVIEW_BLACKLIST_DOMAIN = [
  process.env.NEXT_PUBLIC_GATSBY_MIXPANEL_PROXY_API_ENDPOINT,
  process.env.NEXT_PUBLIC_ORDERS_API_ENDPOINT,
  process.env.NEXT_PUBLIC_STORE_CREDITS_ENDPOINT,
  process.env.NEXT_PUBLIC_SGTM_EVENT_API_ENDPOINT,
]
